module.exports = __webpack_public_path__ + "img/r-cb6-r2-red.0dc0c1f5.gif";